import { Loading } from '@sede-enterprise/shell-ds-react-framework'
import React from 'react'
import Plot from 'react-plotly.js'

const AssetPageChart = ({ loading, dataToPlot, layout, sitePageData }) => {
    return (
        <div className='asset-page-container'>
            {
                !loading ? sitePageData && sitePageData?.length > 0 ?
                    <Plot
                        className="full-size-chart"
                        data={dataToPlot}
                        layout={layout}
                        useResizeHandler={true}
                        style={{ width: "100%", height: "100%" }}
                    /> : <div className='empty-container'>
                        <p className='data-value'>No Data Available</p>
                    </div> : <div className='loading-container' role='status'> <Loading /> </div>
            }

        </div>
    )
}

export default AssetPageChart